angular.module('picmonicng').directive('onboardingTooltip', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        key: '<',
        icon: '<',
        title: '<',
        cta: '<',
        ctaLink: '<',
        position: '<',
        styles: '<',
        stylesPulser: '<',
      },
      templateUrl: '/templates/directives/onboarding-tooltip.html',
      controller: [
        '$scope',
        'UserService',
        function ($scope, UserService) {
          $scope.UserService = UserService;

          $scope.hide = function () {
            UserService.see($scope.key);
          };
        },
      ],
    };
  },
]);
